<template>
  <div class="conteudoInterno" id="atividades">
    <div class="boxSeta">
      <div class="setaScrollstatic" style="" 
          :class="{ 
            setaScroll: setaScrollState 
            }"
      >
        <button><span><i class="bottom"></i></span></button>
      </div> 
    </div>
    <header class="headerSec">
      <h2>Principais Atividades</h2>
      <div class="navSetas">
        <button @click="goBack()" :disabled="clicked"><span><i class="left"></i></span></button>
        <button @click="goNext()" :disabled="clicked"><span :class="{ hideSeta: setaRightState }"><i class="right"></i></span></button>
      </div> 
      <!-- <span></span> -->
    </header>
    <div class="conteudoInternoBox">
      <section class="sectionRow">
        <div class="col23ponto5 marginColBottom">
          <span class="linecol ubcPurpleBack"></span>
        </div>
      </section>
      <section class="sectionRow top65">
        <div class="col23ponto5">
        </div>
        <div class="col66">
          <h4 class="h4Destaque">Aos 80 anos, UBC patrocina livro <span class="ubcPurple sanukBlack">"O Autor Existe"</span>, um panorama da jurisprudência brasileira sobre direitos autorais musicais</h4>

          <p class="top32">Com uma história de oito décadas de lutas, vitórias e reconhecimento dos direitos dos autores brasileiros, a UBC lança o livro “O autor existe. O direito autoral aplicado pelo STJ nos 80 anos da UBC”. Disponível para venda no site da Litteris Editora e em livrarias em todo o país, a obra foi lançada em dezembro passado. Todo o valor obtido com as vendas será doado ao Instituto Zeca Pagodinho, que oferece cursos profissionalizantes e de artes para centenas de crianças em Duque de Caxias, na Baixada Fluminense. </p>
        
          <div class="hidden" v-show="value1">
            <p>Com organização e coordenação de Sydney Sanches e Karina Callai, o livro traz, no decorrer de suas 240 páginas, mais de 10 artigos de algumas das maiores autoridades brasileiras no campo dos direitos autorais. Entre elas, destacam-se colaborações in memoriam de Fernando Brant, compositor, ex-presidente da UBC e figura central na defesa dos direitos dos autores no Brasil, e João Carlos Müller Chaves, advogado e Secretário Geral por cerca de 20 anos na Federação Latino Americana do Produtores Fonográficos (FLAPF).</p>

            <p>Dedicado a Fernando Brant e Erasmo Carlos, o livro traz prefácio assinado por Paulo Sérgio Valle, então diretor-presidente da UBC e autor de mais de mil composições. No texto introdutório, o compositor antecipa o que o leitor encontrará nas páginas. “De alguma forma, os legisladores e julgadores, ao longo da história, demonstraram ter ‘ouvido musical’ e sensibilidade para ouvir a necessidade de proteção da obra artística e seu autor; daí o direito autoral. É o que se vê nas páginas deste livro”, afirma Valle.</p>

            <p>Os organizadores destacam que o livro "resgata os desafios enormes enfrentados para chegarmos até aqui, com a consciência de que o Brasil possui uma legislação autoral avançada, moldada para enfrentar os desafios das novas tecnologias e formas de exploração das obras protegidas, que permite uma aplicação respeitada e, principalmente, consagrada na jurisprudência do STJ.”</p>

            <p>De acordo com Marcelo Castello Branco, diretor-executivo da UBC, mais do que celebrar os 80 anos da UBC, o livro documenta de maneira definitiva o legado de inúmeros profissionais na defesa dos direitos dos autores:</p>

            <p>“Dentro do calendário de 80 anos da UBC, faltava uma ação de registro do protagonismo da entidade na incansável defesa do direito autoral no Brasil. Em sua trajetória, a UBC sempre se colocou ao lado dos titulares de direito, trazendo para o Brasil o conhecimento de práticas internacionais determinantes para o respeito e a valorização da matéria. O livro é um espelho desta identidade fundamental da UBC, suas diretorias nestas oito décadas e as vitórias e desafios do caminho.”</p>
          </div>
          <div v-show="!value1" class="button top32" v-on:click="value1 = !value1" :disabled="clicked">
            <button class="sanukBold"><span>Leia mais </span><div class="leiaMais"></div></button>
          </div>
          <div v-show="value1" class="button top32" v-on:click="value1 = !value1" :disabled="clicked">
            <button class="sanukBold"><span>Fechar  </span><div class="fechar"></div></button>
          </div>
          
          <h4 class="h4Destaque top50">Parcerias com as iniciativas <span class="ubcPurple sanukBlack">Credits Due</span> e <span class="ubcPurple sanukBlack">Session Studio</span></h4>
          <p class="top32">Num esforço contínuo para destacar os identificadores musicais e educar os membros sobre sua importância, a UBC fez parcerias com duas iniciativas relacionadas.</p>

          <p>O Credits Due é uma iniciativa global focada em estimular a indústria da música a garantir que os metadados completos e precisos das músicas estejam vinculados a todas as gravações e canções desde o momento da sua criação.</p>
          <div class="hidden" v-show="value2">
            <p>Foi estabelecida pela The Ivors Academy of Music Creators e pela Music Rights Awareness Foundation em 2021. A UBC deu seu apoio à iniciativa e promoveu um evento conjunto inicial, um painel virtual ao vivo com a participação do diretor-executivo da Ivors Academy, Graham Davies, do produtor brasileiro baseado nos EUA Moogie Canazio e da cantora e compositora brasileira Bibi.</p>

            <p>A UBC também lançou uma parceria com o Session Studio, uma plataforma web e aplicativo que ajuda os criadores a colaborar online, compartilhando desde letras até faixas e mixagens finalizadas, integradas ao seu DAW favorito, garantindo que os metadados dos criadores estejam vinculados aos arquivos do projeto em cada etapa.</p>

            <p>Através de um processo de autorização desenvolvido especificamente para o Portal do Associado da UBC, os afiliados dispõem de uma maneira exclusiva de autorizar a UBC a compartilhar seus identificadores principais com o Session Studio, garantindo que esses identificadores já estejam preenchidos quando forem criados os perfis no Session Studio.</p>

            <p>Em um mercado cada vez mais digital, com um volume crescente de músicas lançadas, o registro e a identificação adequados dos criadores desde o início são mais importantes do que nunca. A UBC tem como objetivo ajudar os criadores a entenderem essa necessidade. E fornecer as ferramentas para fazê-lo.</p>
          </div>
          <div v-show="!value2" class="button top32" v-on:click="value2 = !value2" :disabled="clicked">
            <button class="sanukBold" ><span>Leia mais </span><div class="leiaMais"></div></button>
          </div>
          <div v-show="value2" class="button top32" v-on:click="value2 = !value2" :disabled="clicked">
            <button class="sanukBold" ><span>Fechar </span><div class="fechar"></div></button>
          </div>

          <h4 class="h4Destaque top50"><span class="ubcPurple sanukBlack">Por Elas</span> Que Fazem a Música</h4>

          <p class="top32">Por Elas que Fazem a Música é um relatório pioneiro sobre a participação das mulheres no mercado de música brasileiro, utilizando o banco de dados da UBC - União Brasileira de Compositores como referência. Este trabalho reforça, em sua sexta edição, seu objetivo de promover a discussão sobre equilíbrio de gênero na música, observando e registrando quaisquer mudanças ao longo dos anos. Da mesma forma, reflexões e questionamentos se intensificam agora, em busca de melhorias efetivas. Buscamos continuamente trazer novas perspectivas e nuances para o mercado de música em relação às mulheres.</p>

          <p class="link">Você pode ler o relatório<a href="https://www.canva.com/design/DAFapQP5uzE/3u9h6xto-qT0tlvE4BwTjg/view?utm_content=DAFapQP5uzE&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink#1" target='_blank'> aqui.</a></p>

        </div>
      </section>
    </div>
  </div>
  </template>
  
  <script>
  import { ShareFunctions } from "../assets/js/functions.js";

  export default {
    name: 'AtividadesPrincipais',
    props:['clicked'],
  
    data() {
      return{
        setaScrollState: false,
        setaRightState: false,
        value1: false,
        value2: false,
      }
    },
    mounted() {

      const conteudo = document.querySelector("#atividades");
      conteudo.addEventListener("scroll", ShareFunctions.headerScroll);

    },
    created(){
      this.hideSetaFunc();
    },
    methods: {

      hideSetaFunc: function(){
      let route = this.$route.path;
      if (route === "/AtividadesPrincipais") {
          this.setaRightState = true
        } else { 
          this.setaRightState = false
        }    
      },
      goNext: function(){
        this.$emit("go-next");
      },
      goBack: function(){
        this.$emit("go-back");
      }, 
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

    p a {
      color: #8781D1;
      font-family: 'sanuk-bold';
    }
    .button {
      width: 100%;
      border-bottom: 1px solid #8781D1;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 32px;
    }
    button {
      color: #8781D1;
      cursor: pointer;
      padding-bottom: 4px;
      display: flex;
    }
    .hidden {
      opacity: 1;
      max-height: auto;
      overflow: hidden;
      animation: open .75s ease-in; 
    }
    @keyframes open {
        0%   {max-height: 0; opacity: 0;}
        100% {max-height: 2000px; opacity: 1;}
      }
    .leiaMais::before, .leiaMais::after, .fechar::before, .fechar::after {
      content: '';
      position:absolute;
      background-color: #8781D1;
      transition: transform 0.25s ease-out;
    }
    .leiaMais{
      position: relative;
      width: 15px;
      height: 15px;
      margin-left: 10px
    }
    .leiaMais::before {
      top: 0;
      left:Calc(50% - 1.5px);;
      width: 3px;
      height: 100%;
    }
    .leiaMais::after{
      top: 50%;
      left: 0;
      width: 100%;
      height: 3px;
      margin-top: -1.5px;
    }
    .fechar{
      position: relative;
      width: 15px;
      height: 15px;
      margin-left: 10px
    }
    .fechar::before {
      top: 0;
      left: Calc(50% - 1.5px);;
      width: 3px;
      height: 100%;
      margin-left: -1.5px;
      transform: rotate(90deg);
    }
    .fechar::after {
      top: 50%;
      left: 0;
      width: 100%;
      height: 3px;
      margin-top: -1.5px;
    }

  </style>
